import * as inRange from 'lodash/inRange'

export const SEARCH_MIN_LETTERS_COUNT = 0

export const ABORTED_STATUS_CODE = 0
export const VALIDATION_ERROR_STATUS_CODE = 400
export const UNAUTHORIZED_STATUS_CODE = 401
export const FORBIDDEN_STATUS_CODE = 403
export const NOT_FOUND_STATUS_CODE = 404
export const TOO_MANY_REQUESTS_STATUS_CODE = 429
export const SERVICE_UNAVAILABLE_CODE = 542

export const isServerFailedError = (status: number) =>
  inRange(status, 500, 600)
